export const avalibility = [
  { type: 'common', color: 'black' },
  { type: 'seasonal', color: 'red' },
  { type: 'event', color: 'blue' },
  { type: 'collab', color: 'green' },
  { type: 'promo', color: '#808000' }
]